import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { IpfsApiKeySchema } from "../../../utils/validations";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { useCallback, useEffect } from "react";
import {
  selectSelectedWeb3ApiKey,
  selectShowWeb3ApiKeyEditor,
  selectWeb3AuthEndpointActionLoading,
  handleHideApiKeyEditor,
  selectWeb3AuthEndpoint,
  selectWeb3AuthEndpointLoading,
  getWeb3AuthEndpointApiKeysAsync,
  updateWeb3AuthEndpointApiKeyAsync,
  createWeb3AuthEndpointApiKeyAsync,
} from "../../../store/web3-auth/web3AuthEndpointSlice";
import { Button, Modal, Input } from "djuno-design";

const Web3ApiKeyEditorModal = () => {
  const endpoint = useAppSelector(selectWeb3AuthEndpoint);
  const endpointLoading = useAppSelector(selectWeb3AuthEndpointLoading);
  const isOpen = useAppSelector(selectShowWeb3ApiKeyEditor);
  const loading = useAppSelector(selectWeb3AuthEndpointActionLoading);
  const apiKey = useAppSelector(selectSelectedWeb3ApiKey);
  const dispatch = useAppDispatch();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(IpfsApiKeySchema),
  });

  useEffect(() => {
    if (isOpen && apiKey) {
      setValue("label", apiKey.Label);
    }
  }, [isOpen, apiKey, setValue]);

  const onSubmit = (data: any) => {
    if (endpoint)
      if (apiKey) {
        dispatch(
          updateWeb3AuthEndpointApiKeyAsync({
            endpointId: endpoint.Id,
            id: apiKey.Id,
            data: {
              label: data.label,
            },
          })
        ).then((action) => {
          if (action.type === "web3-auth/endpoint/api-keys/update/fulfilled") {
            reset();
            dispatch(handleHideApiKeyEditor());
            dispatch(getWeb3AuthEndpointApiKeysAsync(endpoint.Id.toString()));
          }
        });
      } else {
        dispatch(
          createWeb3AuthEndpointApiKeyAsync({
            endpointId: endpoint.Id,
            data: {
              label: data.label,
            },
          })
        ).then((action) => {
          if (action.type === "web3-auth/endpoint/api-keys/create/fulfilled") {
            reset();
            dispatch(handleHideApiKeyEditor());
            dispatch(getWeb3AuthEndpointApiKeysAsync(endpoint.Id.toString()));
          }
        });
      }
  };

  const handleOnClose = useCallback(() => {
    dispatch(handleHideApiKeyEditor());
    reset();
  }, [dispatch, reset]);

  useEffect(() => {
    return () => {
      handleOnClose();
    };
  }, [handleOnClose]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleOnClose}
      contentClassName="max-w-lg"
      title={apiKey ? "Update API key" : "Create new API key"}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mt-5 flex flex-col w-full gap-5">
          <Input
            label="API key label"
            {...register("label")}
            error={errors.label?.message}
            placeholder=""
            required
          />
        </div>
        <div className="mt-4 flex justify-end">
          <Button
            loading={loading}
            uiType="primary"
            disabled={loading || endpointLoading}
            type="submit"
            className="w-[100px]"
          >
            {apiKey ? "Update" : "Create"}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default Web3ApiKeyEditorModal;
